import dynamic from "next/dynamic";

export const DynamicPhotoGalleryDialog = dynamic(() =>
  import("~/components/schema-render/common/div/photo-gallery/photo-gallery-dialog").then(
    module => module.PhotoGalleryDialog,
  ),
);
